var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2,20c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41V6c0-.55.2-1.02.59-1.41s.86-.59,1.41-.59h2c0-1.1.39-2.04,1.18-2.83s1.73-1.18,2.83-1.18,2.04.39,2.83,1.18,1.18,1.73,1.18,2.83h2c.55,0,1.02.2,1.41.59s.59.86.59,1.41v12c0,.55-.2,1.02-.59,1.41s-.86.59-1.41.59H2Zm0-2h12V6h-2v2c0,.28-.1.52-.29.71s-.43.29-.71.29-.52-.1-.71-.29-.29-.43-.29-.71v-2h-4v2c0,.28-.1.52-.29.71s-.43.29-.71.29-.52-.1-.71-.29-.29-.43-.29-.71v-2h-2v12ZM6,4h4c0-.55-.2-1.02-.59-1.41s-.86-.59-1.41-.59-1.02.2-1.41.59-.59.86-.59,1.41Zm-4,14V6v12Z",
    fill: "#302e49",
    strokeWidth: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.cf07867c.svg";
export { ForwardRef as ReactComponent };